import { useRouteMatch } from 'react-router-dom'

import { UnityHubChannelIcon, TUnityHubChannelIconProps } from 'App/components/UnityHub'
import { UnityHubRoomNavLinkInline } from 'App/components/UnityHub/UnityHubRoomNavLinkInline'

export type TEventsHighlightRoomProps = {
  path: string
  name: string
  iconVariant: TUnityHubChannelIconProps['variant']
}

export const EventsHighlightRoom = ({ path, iconVariant, name }: TEventsHighlightRoomProps) => {
  const { url } = useRouteMatch()

  return (
    <UnityHubRoomNavLinkInline
      to={`${url}/${path}`}
      icon={<UnityHubChannelIcon variant={iconVariant} gutter={false} />}
      name={name}
    />
  )
}
